import { FormFieldGroup, FormLabel, FormTextarea } from '$components'
import { Input } from '.'

export function CreateSupportTicketFormContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Message}>
          Message
        </FormLabel>

        <FormTextarea
          name={Input.Message}
          placeholder="Describe the issue or question..."
          rows={6}
        />
      </FormFieldGroup>
    </div>
  )
}
